import { useEffect, useState } from "react";
import { useAuth } from "shared/hooks/auth";
import { obterTiposPermitidos } from "../services/materiaisN1";

/**
 * FASE 05 — 2ª validação/PO 2026-07-24 (B4): indica se a empresa logada está com a
 * chave "Liberação dos cadastros apenas para consulta". As telas de detalhe de
 * Produtos N1 usam o retorno para abrir em modo somente-leitura (campos bloqueados,
 * sem botões de gravação). Reaproveita o endpoint ObterTiposPermitidos.
 */
export const useApenasConsulta = (): boolean => {
  const { user } = useAuth();
  const [apenasConsulta, setApenasConsulta] = useState<boolean>(false);

  useEffect(() => {
    const idEmpresa = user?.idEmpresa;
    if (!idEmpresa) return;

    let ativo = true;
    obterTiposPermitidos(idEmpresa).then((resposta) => {
      if (ativo && resposta) {
        setApenasConsulta(resposta.apenasConsulta);
      }
    });

    return () => {
      ativo = false;
    };
  }, [user?.idEmpresa]);

  return apenasConsulta;
};
